<div class="margin-bottom-lg">
	<edit-child-demographic-termination #editChildDemographicTermination [studentId]="studentId" [(editing)]="editing">
	</edit-child-demographic-termination>
</div>
<div class="padding-top-sm margin-bottom-md">
	<edit-child-demographic-general #editChildDemographicGeneral [studentId]="studentId" [(editing)]="editing">
	</edit-child-demographic-general>
</div>
<div class="margin-bottom-md">
	<edit-child-demographic-parents #editChildDemographicParents [studentId]="studentId"
		[(editing)]="editing"></edit-child-demographic-parents>
</div>
<div class="margin-bottom-md">
	<edit-child-demographic-identifiers #editChildDemographicIdentifiers [studentId]="studentId" [(editing)]="editing">
	</edit-child-demographic-identifiers>
</div>

<button mat-raised-button color="primary" (click)="confirmSave()" *ngIf="editing">
	Confirm Save
</button>

<app-msg *ngFor="let msg of messages" [msg]="msg"></app-msg>